<mat-form-field appearance="legacy" style="height:35px;margin-left:10px;font-size:small;">
  <mat-label>Accès</mat-label>
  <mat-select [(value)]="selectedAccess.id">
      <mat-option *ngFor="let access of accesses" (click)="select(access)" [value]="access.id">{{access.access}}</mat-option>
  </mat-select>
</mat-form-field>